// import Cookies from "js-cookie";
// import { useMemo } from "react";
// import { useLocation } from "react-router";

// let TOKEN: string | null = null;

// export function getAuthToken() {
//   const cookieToken = Cookies.get("fp_access_token") ?? null;
//   if (cookieToken !== TOKEN) {
//     // apolloClient?.resetStore().catch((error) => {
//     //   if (error.message.includes("Invariant")) {
//     //     return;
//     //   }
//     //   captureException(error);
//     // });
//     TOKEN = cookieToken;
//   }

//   return TOKEN;
// }

// export const useAuth = () => {
//   const token = getAuthToken();
//   const location = useLocation();
//   const isAuthenticated = useMemo(() => !!token, [token, location]);

//   return {
//     token,
//     isAuthenticated,
//   };
// };

import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";

export const useAuth = () => {
  const getEffectiveToken = () => {
    const tokenCookie = Cookies.get("token") ?? null;
    const fpToken = Cookies.get("fp_access_token") ?? null;

    if (tokenCookie) return tokenCookie;
    if (fpToken) {
      Cookies.set("token", fpToken);
      return fpToken;
    }
    return null;
  };

  const [token, setToken] = useState(getEffectiveToken);
  const lastTokenRef = useRef<string | null>(token);
  const lastFpTokenRef = useRef<string | null>(
    Cookies.get("fp_access_token") ?? null,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const fpToken = Cookies.get("fp_access_token") ?? null;
      const tokenCookie = Cookies.get("token") ?? null;

      if (fpToken !== lastFpTokenRef.current) {
        lastFpTokenRef.current = fpToken;
        if (fpToken) {
          Cookies.set("token", fpToken);
          if (fpToken !== lastTokenRef.current) {
            lastTokenRef.current = fpToken;
            setToken(fpToken);
          }
          return;
        }
      }

      const nextToken = tokenCookie ?? fpToken ?? null;
      if (!nextToken) {
        if (tokenCookie) {
          Cookies.remove("token");
        }
        if (nextToken !== lastTokenRef.current) {
          lastTokenRef.current = null;
          setToken(null);
        }
        return;
      }

      if (nextToken !== lastTokenRef.current) {
        lastTokenRef.current = nextToken;
        setToken(nextToken);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const isAuthenticated = !!token;

  return { token, isAuthenticated };
};
